import React from 'react';
import { Operation } from '../../Transactions.types';
import { OperationListItem } from '../OperationListItem';
import * as S from './OperationsList.styles';

interface OperationsListProps {
  operations: Operation[];
  onShowDetails: (operation: Operation) => void;
}

export function OperationsList({
  operations,
  onShowDetails,
}: OperationsListProps) {
  return (
    <S.Container>
      {operations.map(operation => (
        <OperationListItem
          key={operation.id}
          operation={operation}
          onShowDetails={onShowDetails}
        />
      ))}
    </S.Container>
  );
}
